import type { GalleryV1Attributes } from '@/features/gallery-v1/gallery-v1-type';

import React from 'react';

import dynamic from 'next/dynamic';

import { isVideo } from '@/core/features/video/video-service';
import { bemModule } from '@/core/utils/bem-classname';
import GalleryAdditionalImageLayer from '@/features/gallery-v1/gallery-elements/gallery-additional-image-layer';
import GalleryImage from '@/features/gallery-v1/gallery-elements/gallery-image';

import styles from './gallery-v1-desktop.module.scss';

const bem = bemModule(styles);

const GallerySwiperOverlayDesktop = dynamic(
    () =>
        import(
            /* webpackChunkName: "GallerySwiperOverlayDesktop" */ '@/features/gallery-v1/gallery-desktop/gallery-swiper-overlay-desktop/gallery-swiper-overlay-desktop'
        ),
);

export default function GalleryV1Desktop({ firstViewImageCount, gallery, overlayTitle }: GalleryV1Attributes) {
    const imageCount = firstViewImageCount ?? 5;

    const [sliderOverlayOpen, setSwiperOverlayOpen] = React.useState(false);
    const [initialSlide, setInitialSlide] = React.useState(0);

    const openSwiperOverlay = (initialSlide: number) => {
        setInitialSlide(initialSlide);
        setSwiperOverlayOpen(true);
    };

    return (
        <div
            className={`${bem(styles.container, {
                hasOneImage: imageCount === 1,
                hasThreeImages: imageCount === 3,
                hasTwoImages: imageCount === 2,
            })}`}
        >
            {gallery.slice(0, imageCount).map((item, index) => {
                const image = isVideo(item) ? item.poster : item;
                const imageHeight = () => {
                    if (index === 0) {
                        return 460;
                    } else if (imageCount === 2) {
                        return 460;
                    }
                    return 227.5;
                };

                return (
                    <div
                        className={`${styles.image} ${styles[`image${index + 1}`]}`}
                        data-qa-id={'qa-gallery-images-desktop'}
                        key={`${image.imageAlt} + ${index}`}
                        onClick={() => openSwiperOverlay(index)}
                    >
                        <GalleryImage
                            height={imageHeight()}
                            image={isVideo(item) ? item.poster : item}
                            isVideo={isVideo(item)}
                            layoutWidth={index < 2 ? 50 : 20}
                            preload={true}
                        />
                        <GalleryAdditionalImageLayer
                            gallery={gallery}
                            imageCount={imageCount}
                            index={index}
                        />
                    </div>
                );
            })}
            {sliderOverlayOpen && (
                <GallerySwiperOverlayDesktop
                    gallery={gallery}
                    initialSlide={initialSlide}
                    onClose={() => setSwiperOverlayOpen(false)}
                    title={overlayTitle}
                />
            )}
        </div>
    );
}
